import React, {useState, useEffect} from 'react';
import {getCurrentMatic, getPearlBalance, getMintBalance} from './helpers/racefunctions';
import { LeftMenu } from './leftMenu';
import { MenuDisplay } from './menuDisplay';



export function RaceDisplay ( {id, walletAddress, setModalInfo, setMessage, stakedRacers, weekInfo, currWeek, accountName, setAccountName, setCurrStakedRacers, setWallet, setStatus} )  {

    const newid = id;
    const [maticAvail, setMaticAvail] = useState(0);
    const [pearlsAvail, setPearlsAvail] = useState(0);
    const [mintsAvail, setMintsAvail] = useState(0);
    const [hydroAvail, setHydroAvail] = useState(0);
    const [menuSelection, setMenuSelection] = useState("account");
    const [leagueToManage, setLeageToManage] = useState("");
    const [currManagementSel, setCurrManSel] = useState("overview");
    
 
    
    const currcollections = require('./json/collections.json');

    useEffect(()=>{
        if (walletAddress !== ''){
  //      if (newid === "open" || newid === "completed" || newid === "account"){
  //              getRaceInfo();
  //      }
        loadInit();
    }
        
    setMessage("");

    }, [newid, walletAddress])



    const loadInit = async () => {
        
            setMessage("Loading Available Amounts.");
            let curmatic = await getCurrentMatic(walletAddress);
            setMaticAvail(parseFloat(curmatic).toFixed(4));
            let curpearls = await getPearlBalance(walletAddress);
            setPearlsAvail(parseFloat(curpearls).toFixed(0));
            let curmints = await getMintBalance(walletAddress);
            setMintsAvail(parseInt(curmints));

            
            setMessage("")
        
    }


 //   const showRace = (race) => {
 
 //       window.open('/?race=' + race, '_blank');
//    }

   


 
 


    const selectMenuOption = (sel) => {
        setMenuSelection(sel);
    }

    const selectManageLeague = (sel) => {
  
        setLeageToManage(sel);
    }

    const selectManageSection = (sel) => {
        setCurrManSel(sel);
    }


//    if (walletAddress === ''){
//            return (<div style={{color:'white'}}>Please connect wallet.</div>)
//    }else{

            return (<><div className="row" style={{paddingTop:'20px'}}>
                <LeftMenu menuSelection={menuSelection} selectMenuOption={selectMenuOption} selectManageLeague={selectManageLeague} leagueToManage={leagueToManage} currManagementSel={currManagementSel} selectManageSection={selectManageSection}  />
                <div className='col-md-10' style={{backgroundColor:'rgba(0,0,0,.4)'}}>
                <MenuDisplay menuSelection={menuSelection} walletAddress={walletAddress} setMessage={setMessage} setModalInfo={setModalInfo} maticAvail={maticAvail} pearlsAvail={pearlsAvail} mintsAvail={mintsAvail} currcollections={currcollections} stakedRacers={stakedRacers} weekInfo={weekInfo} currWeek={currWeek} accountName={accountName} setAccountName={setAccountName} setCurrStakedRacers={setCurrStakedRacers} leagueToManage={leagueToManage} currManagementSel={currManagementSel} selectManageSection={selectManageSection} hydroAvail={hydroAvail}  setStatus={setStatus} setWallet={setWallet} />
                </div>

                </div></>)
        
  //  }
    

}
